import request from '@/utils/request'
// import { Notification } from 'element-ui'

export function getProvinceList() {
  return request({
    url: '/ProvinceMunicipal/getProvinceList',
    method: 'post'
  })
}

export function getLowerCity(id) {
  return request({
    url: `/ProvinceMunicipal/getLowerCity/${id}`,
    method: 'post'
  })
}
